
define('modules/application/calculationClasses/intrusionDetection',[
    "app",

    // Libs
    "backbone"
  ],

  function(app, Backbone) {

    var CalculationClass = {};

    CalculationClass.resetValues = function() {
      //Resetting values
      BticinoS4B.solution.intrusionDetection.externalItems = [];
      BticinoS4B.solution.intrusionDetection.zonesItems = [];
      BticinoS4B.Instances.Models.ApplicationModel.set("externalItems", []);
      BticinoS4B.Instances.Models.ApplicationModel.set("zonesItems", []);
    };

    CalculationClass.startAutomaticCalculation = function() {
      CalculationClass.resetValues();

      //Requesting model delivery
      window.BticinoS4B.eventAggregator.trigger("modelDeliver:request", this);

      var automaticCalculationModel = {
        kits: [],
        externalItems: [],
        zones: []
      };
      var externalSirens, internalSirens, mainControlUnit, remoteControls, radioSystems, kits, zone, interfacesToOptimize = [],
        optimizedInterfaces = [];
      var k = 1,
        l = 0,
        i = 0,
        j = 0,
        m = 0;

      if (!automaticCalculationModel.automaticItems) automaticCalculationModel.automaticItems = [];

      //Kits
      if (BticinoS4B.Instances.Models.ApplicationModel.get && BticinoS4B.Instances.Models.ApplicationModel.get("kits")) {
        for (i = 0; i < BticinoS4B.Instances.Models.ApplicationModel.get("kits").length; i++) {
          automaticCalculationModel.kits.push({
            "progNumber": k,
            "packageClassId": BticinoS4B.Instances.Models.ApplicationModel.get("kits")[i].packageClassId,
            "productCode": BticinoS4B.Instances.Models.ApplicationModel.get("kits")[i].productCode,
            "quantity": 1
          });
          k++;
        }
      }

      //Power supply
      if (BticinoS4B.Instances.Models.ApplicationModel.get && BticinoS4B.Instances.Models.ApplicationModel.get("powerSupply")) {
        automaticCalculationModel.externalItems.push({
          "progNumber": k,
          "packageClassId": BticinoS4B.Instances.Models.ApplicationModel.get("powerSupply").get("packageClassId"),
          "productCode": BticinoS4B.Instances.Models.ApplicationModel.get("powerSupply").get("productCode"),
          "quantity": 1,
          "isArticleSystem": true
        });
        k++;
      }

      //Sirens
      if (BticinoS4B.Instances.Models.ApplicationModel.get && BticinoS4B.Instances.Models.ApplicationModel.get("sirens")) {
        externalSirens = BticinoS4B.Instances.Models.ApplicationModel.get("sirens").get("externalSirens");
        internalSirens = BticinoS4B.Instances.Models.ApplicationModel.get("sirens").get("internalSirens");
        mainControlUnit = BticinoS4B.Instances.Models.ApplicationModel.get("mainControlUnit");

        //External sirens
        for (i = 0; i < externalSirens.length; i++) {
          for (j = 0; j < externalSirens[i].value; j++) {
            automaticCalculationModel.externalItems.push({
              "progNumber": k,
              "packageClassId": externalSirens[i].packageClassId,
              "productCode": externalSirens[i].productCode,
              "quantity": 1,
              "isExternalSiren": true
            });
            k++;
          }
        }

        //Internal sirens
        for (i = 0; i < internalSirens.value; i++) {
          automaticCalculationModel.externalItems.push({
            "progNumber": k,
            "packageClassId": internalSirens.packageClassId,
            "productCode": internalSirens.productCode,
            "quantity": 1,
            "isInternalSiren": true
          });
          k++;
        }
      }

      //Main control unit
      if (mainControlUnit.get && mainControlUnit) {
        var slots = [];
        if (mainControlUnit.get("specialVars").contacts) {
          var z;
          for (i = 0; i < mainControlUnit.get("specialVars").contacts.length; i++) {
            z = "Z" + [i];
            slots.push({
              z: mainControlUnit.get("specialVars").contacts[i].connectedTo
            });
          }
        }
        automaticCalculationModel.externalItems.push({
          "progNumber": k,
          "packageClassId": mainControlUnit.get("packageClassId"),
          "productCode": mainControlUnit.get("productCode"),
          "quantity": 1,
          "slot": slots,
          "isArticleSystem": true
        });
        k++;
      }

      //Remote controls
      if (BticinoS4B.Instances.Models.ApplicationModel.get && BticinoS4B.Instances.Models.ApplicationModel.get("remoteControls")) {
        remoteControls = BticinoS4B.Instances.Models.ApplicationModel.get("remoteControls").get("remotes");
        for (i = 0; i < remoteControls.length; i++)
          for (j = 0; j < remoteControls[i].get("products").length; j++)
            for (l = 0; l < remoteControls[i].get("products")[j].get("value"); l++) {
              automaticCalculationModel.externalItems.push({
                "progNumber": k,
                "packageClassId": remoteControls[i].get("products")[j].get("packageClassId"),
                "productCode": remoteControls[i].get("products")[j].get("productCode"),
                "quantity": 1,
                "isArticleSystem": true
              });
              k++;
            }
      }

      if (BticinoS4B.Instances.Models.ApplicationModel.get && BticinoS4B.Instances.Models.ApplicationModel.get("zones")) {
        var additionalZonesCollection = BticinoS4B.Instances.Models.ApplicationModel.get("additionalZones");
        var zoneCollection = BticinoS4B.Instances.Models.ApplicationModel.get("zones").collection.models;
        var itemToAdd = {},
          zoneToSend = {},
          alarmToAdd = {};

        //Inserters zone
        zoneToSend = {};
        zoneToSend.zoneNumber = 0;//-1;
        zoneToSend.zoneName = "IDS_WAI1001_9006";
        zoneToSend.board = "Q0";
        zoneToSend.items = [];

        for (i = 0; i < additionalZonesCollection.length; i++) {
          if (additionalZonesCollection[i].attributes && additionalZonesCollection[i].get("name") === "IDS_WAI1001_9006") {

            var inserters = additionalZonesCollection[i].get("insertersModel");
            if (inserters) {
              inserters = inserters.get("collection");
              for (j = 0; j < inserters.length; j++) {
                zoneToSend.items.push({
                  "progNumber": k,
                  "packageClassId": inserters.models[j].get("packageClassId"),
                  "productCode": inserters.models[j].get("productCode"),
                  "quantity": 1
                });
                k++;
              }
            }

          }
        }
        //Radio systems
        if (BticinoS4B.Instances.Models.ApplicationModel.get && BticinoS4B.Instances.Models.ApplicationModel.get("radioSystems")) {
          radioSystems = BticinoS4B.Instances.Models.ApplicationModel.get("radioSystems");

          //Interfaces
          if (radioSystems.get("interfaces")) {
            for (i = 0; i < radioSystems.get("interfaces").length; i++) {
              for (j = 0; j < radioSystems.get("interfaces")[i].get("value"); j++) {
                zoneToSend.items.push({
                  "progNumber": k,
                  "packageClassId": radioSystems.get("interfaces")[i].get("packageClassId"),
                  "productCode": radioSystems.get("interfaces")[i].get("productCode"),
                  "quantity": 1
                });
                k++;
              }
            }
          }

          //Remotes
          if (radioSystems.get && radioSystems.get("remotes")) {
            for (i = 0; i < radioSystems.get("remotes").length; i++) {
              for (j = 0; j < radioSystems.get("remotes")[i].get("value"); j++) {
                zoneToSend.items.push({
                  "progNumber": k,
                  "packageClassId": radioSystems.get("remotes")[i].get("packageClassId"),
                  "productCode": radioSystems.get("remotes")[i].get("productCode"),
                  "quantity": 1
                });
                k++;
              }
            }
          }
        }

        automaticCalculationModel.zones.push(zoneToSend);

        //Regular zone
        var interfaceToAdd, protectionToAdd, protectionsToAdd = [];
        for (i = 0; i < zoneCollection.length; i++) {
          zoneToSend = {};
          zoneToSend.zoneNumber = zoneCollection[i].get("number");
          zoneToSend.zoneName = zoneCollection[i].get("name");
          zoneToSend.board = "Q0";
          zoneToSend.items = [];

          if (zoneCollection[i].get("volumetricProtectionModel").get("collection")) {
            for (l = 0; l < zoneCollection[i].get("volumetricProtectionModel").get("collection").models.length; l++) {
              itemToAdd = {};
              itemToAdd.progNumber = k;
              itemToAdd.quantity = 1;
              itemToAdd.packageClassId = zoneCollection[i].get("volumetricProtectionModel").get("collection").models[l].get("packageClassId");
              itemToAdd.productCode = zoneCollection[i].get("volumetricProtectionModel").get("collection").models[l].get("productCode");
              zoneToSend.items.push(itemToAdd);
              k++;
            }
          }

          if (zoneCollection[i].get("perimetralProtectionModel").get("collection"))
            for (l = 0; l < zoneCollection[i].get("perimetralProtectionModel").get("collection").models.length; l++) {
              zone = zoneCollection[i].get("perimetralProtectionModel").get("collection").models[l];

              //Interface
              if (zone.get("_interface")) {
                interfaceToAdd = _.extend(zone.get("_interface"), {
                  progNumber: k,
                  quantity: 1,
                  packageClassId: zone.get("_interface").packageClassId,
                  productCode: zone.get("_interface").productCode
                });
                k++;
              }

              protectionsToAdd = [];
              interfaceToAdd.attachedProducts = [];

              //Protections
              if (zone.get("protections")) {
                for (j = 0; j < zone.get("protections").length; j++) {
                  if (zone.get("protections")[j].get("state") === "0") {
                    for (m = 0; m < zone.get("protections")[j].get("value"); m++) {
                      protectionToAdd = {
                        idLink: zone.get("protections")[j].get("number"),
                        progNumber: k,
                        quantity: 1,
                        packageClassId: zone.get("protections")[j].get("type").packageClassId,
                        productCode: zone.get("protections")[j].get("type").productCode,
                        Slots: 1,
                        Zone: zoneToSend.zoneNumber
                      };

                      if (m === 0) {
                        if (zone.get("protections")[j].get("value") > 1)
                          protectionToAdd.multipleValue = zone.get("protections")[j].get("value");

                        interfaceToAdd.attachedProducts.push(protectionToAdd);
                      }
                      protectionsToAdd.push(protectionToAdd);
                      k++;
                    }
                  } else if (zone.get("protections")[j].get("state") === "1") {
                    interfaceToAdd.optimizable = true;
                  }
                }
              }

              //Pushing interfaces to the externalItems section
              /**interfacesToOptimize.push(interfaceToAdd);**/
              automaticCalculationModel.automaticItems.push(interfaceToAdd);

              for (j = 0; j < protectionsToAdd.length; j++) {
                zoneToSend.items.push(protectionsToAdd[j]);
              }
            }

          if (zoneCollection[i].get("radioSensorsModel").get("collection"))
            for (l = 0; l < zoneCollection[i].get("radioSensorsModel").get("collection").models.length; l++) {
              itemToAdd = {};
              itemToAdd.progNumber = k;
              itemToAdd.quantity = 1;
              itemToAdd.packageClassId = zoneCollection[i].get("radioSensorsModel").get("collection").models[l].get("packageClassId");
              itemToAdd.productCode = zoneCollection[i].get("radioSensorsModel").get("collection").models[l].get("productCode");
              zoneToSend.items.push(itemToAdd);
              k++;
            }

          automaticCalculationModel.zones.push(zoneToSend);
        }

        //Auxiliary zone
        zoneToSend = {};
        zoneToSend.zoneNumber = 9;
        zoneToSend.zoneName = "IDS_WAI1001_9007";
        zoneToSend.board = "Q0";
        zoneToSend.items = [];

        for (i = 0; i < additionalZonesCollection.length; i++) {
          if (additionalZonesCollection[i].attributes && additionalZonesCollection[i].get("name") === "IDS_WAI1001_9007") {

            var technicalBusAlarm = additionalZonesCollection[i].get("technicalBusAlarmModel");
            if ((technicalBusAlarm) && (technicalBusAlarm.get("collection"))) {
              technicalBusAlarm = technicalBusAlarm.get("collection");
              for (j = 0; j < technicalBusAlarm.models.length; j++) {

                //Interface
                itemToAdd = {
                  "progNumber": k,
                  "packageClassId": technicalBusAlarm.models[j].get("_interface").packageClassId,
                  "productCode": technicalBusAlarm.models[j].get("_interface").productCode,
                  "quantity": 1,
                  "attachedProducts": []
                };
                k++;

                //Alarm
                alarmToAdd = {
                  "idLink": k,
                  "progNumber": k,
                  "packageClassId": technicalBusAlarm.models[j].get("type").packageClassId,
                  "productCode": technicalBusAlarm.models[j].get("type").productCode,
                  "Slots": 1,
                  "quantity": 1,
                  "Zone": zoneToSend.zoneNumber
                };

                itemToAdd.attachedProducts.push(alarmToAdd);
                zoneToSend.items.push(itemToAdd);
                zoneToSend.items.push(alarmToAdd);
                k++;
              }
            }

            var technicalRadioAlarm = additionalZonesCollection[i].get("technicalRadioAlarmModel");
            if (technicalRadioAlarm && technicalRadioAlarm.get("collection")) {
              technicalRadioAlarm = technicalRadioAlarm.get("collection");
              for (j = 0; j < technicalRadioAlarm.models.length; j++) {
                zoneToSend.items.push({
                  "progNumber": k,
                  "packageClassId": technicalRadioAlarm.models[j].get("packageClassId"),
                  "productCode": technicalRadioAlarm.models[j].get("productCode"),
                  "quantity": 1
                });
                k++;
              }
            }
          }
        }

        automaticCalculationModel.zones.push(zoneToSend);

      }

      //Interfaces optimization
      var dataProvider = BticinoS4B.Instances.Models.ApplicationModel.get("wizardModel").get("dataProvider");
      dataProvider.addItems("automaticItems", this.optimizeInterfaces(automaticCalculationModel.automaticItems));
      automaticCalculationModel.automaticItems = optimizedInterfaces;

      this.set("automaticCalculationModel", automaticCalculationModel);
      BticinoS4B.Instances.Models.ApplicationModel.set("automaticProducts", _.extend({}, this.get("automaticCalculationModel")));

      this.createConfiguration();
    };

    /**
     * This method optimize interfaces passed as a parameter and return them back
     * @param  {[Array]} interfacesToOptimize [The interfaces that need optimization]
     * @return {[Array]}                      [An array of optimized interfaces]
     */
    CalculationClass.optimizeInterfaces = function(interfacesToOptimize) {

      //Iterator varibales
      var i = 0,
        j = 0,
        m = 0,
        product;

      //Logic variables
      var interfacesLength = interfacesToOptimize.length;
      var optimizableInterfaces = _.filter(interfacesToOptimize, function(currentInterface) {
        return currentInterface.optimizable;
      });
      var nonOptimizableInterfaces = _.filter(interfacesToOptimize, function(currentInterface) {
        return (!currentInterface.optimizable);
      });
      var optimizedInterfaces = [];

      //Grouping interfaces for package class
      optimizableInterfaces = _.groupBy(optimizableInterfaces, function(currentInterface) {
        return currentInterface.packageClassId;
      });

      for (product in optimizableInterfaces) {
        for (i = 0; i < optimizableInterfaces[product].length; i++) {
          if ((i + 1) < optimizableInterfaces[product].length) {
            if (optimizableInterfaces[product][i].optimizable) {
              optimizableInterfaces[product][i].attachedProducts.push(optimizableInterfaces[product][i + 1].attachedProducts[0]);
              optimizableInterfaces[product][i + 1].optimizable = false;
              optimizedInterfaces.push(optimizableInterfaces[product][i]);
            }
          } else if (optimizableInterfaces[product][i].optimizable) {
            optimizedInterfaces.push(optimizableInterfaces[product][i]);
          }
        }
      }

      var returnableInterfaces = _.union(nonOptimizableInterfaces, optimizedInterfaces);

      for (i = 0; i < returnableInterfaces.length; i++) {
        if (returnableInterfaces[i].wizardChoices && returnableInterfaces[i].wizardChoices.length === 1)
          _.extend(returnableInterfaces[i], returnableInterfaces[i].wizardChoices[0]);
      }

      return returnableInterfaces;
    };

    CalculationClass.createConfiguration = function() {

      /*
      
        ASSEGNAZIONE DELLE ZONE
        -104      : articoli di sistema (centrale, alimentatore, primo contatto della centrale, secondo contatto della centrale)
        -103      : sirene esterne
        -102      : sirene interne
        -101      : fuori zona
           0      : inseritori
           1-> 8  : zone create nel progetto
           9      : ausiliari

        Non bisogna passare al serivzio gli mnemonici maggiori di 1 dei pacchetti
        Passare i packageClassId di tutte le entità
      */

      //Counters
      var i, j, l, g, k = 1,
        counter = 0,
        productToAdd, productQuantity, validitiesLength;
      var sobstitutionMatrix = [];
      var dataProvider = BticinoS4B.Instances.Models.ApplicationModel.get("wizardModel").get("dataProvider");

      //Model to send
      var modelToSend = {
        token: window.BticinoS4B.token,
        items: []
      };

      //Submodel
      var externalItems = dataProvider.get("items").externalItems ? dataProvider.get("items").externalItems : null,
        externalItemsLength = externalItems ? externalItems.length : 0;

      var zones = dataProvider.get("items").zonesItems ? dataProvider.get("items").zonesItems : null,
        zonesLength = zones ? zones.length : 0;

      var automaticItems = dataProvider.get("items").automaticItems ? dataProvider.get("items").automaticItems : null,
        automaticItemsLength = automaticItems ? automaticItems.length : 0;

      var optionalPackages = BticinoS4B.Instances.Models.ApplicationModel.get("optionalPackages"),
        optionalPackagesLength = optionalPackages.length;

      var plainProducts = [];
      modelToSend = [];

      //Adding external items to plain products array
      for (i = 0; i < externalItemsLength; i++) {
        productToAdd = _.extend({}, externalItems[i]);
        if (productToAdd.packageClassId && productToAdd.packageClassId !== "2002") {
          productQuantity = productToAdd.quantity;
          //productToAdd.zone      = 0;
          productToAdd.aux = "";

          for (j = 0; j < productQuantity; j++) {
            productToAdd.newProgNumber = k;
            plainProducts.push(_.extend({
              attachedProducts: []
            }, productToAdd));
            k++;
          }
        }
      }

      //Adding optional items to plain products array
      for (i = 0; i < optionalPackagesLength; i++) {
        var packageToAdd = _.extend({}, optionalPackages[i]);
        var packageProducts = packageToAdd.get("products").packagesByOptionalPackageId;
        var packageProductsLength = packageProducts.length;

        for (l = 0; l < packageProductsLength; l++) {
          productToAdd = _.extend(packageProducts[l]);
          productQuantity = 0;
          var productPackageClassId = "";

          if (productToAdd.attributes) {
            productQuantity = productToAdd.get("value");
            productPackageClassId = productToAdd.get("packageClassId");
          } else {
            productQuantity = productToAdd.value;
            productPackageClassId = productToAdd.packageClassId;
          }
          var zoneValue = -101;//0;

          //Exception for IR interface
          if (productPackageClassId === "2101")
            zoneValue = 99;

          productToAdd = {
            zone: zoneValue,
            aux: "",
            packageClassId: productPackageClassId
          };

          for (j = 0; j < productQuantity; j++) {
            productToAdd.newProgNumber = k;
            plainProducts.push(_.extend({}, productToAdd));
            k++;
          }
        }
      }

      //Adding zone items to plain products array
      for (i = 0; i < zonesLength; i++) {
        var zoneLength = zones[i].items.length;

        for (j = 0; j < zoneLength; j++) {
          productToAdd = _.extend({}, zones[i].items[j]);

          productQuantity = productToAdd.quantity;
          //delete productToAdd.quantity;

          productToAdd.zone = /*zones[i].zoneNumber || */ zones[i].number;
          productToAdd.aux = "";

          for (l = 0; l < productQuantity; l++) {
            productToAdd.newProgNumber = k;
            plainProducts.push(_.extend({
              attachedProducts: []
            }, productToAdd));
            k++;
          }
        }
      }

      //Adding autocalculated items
      var iterator = function(item) {
        return item.progNumber;
      };

      for (i = 0; i < automaticItemsLength; i++) {
        validitiesLength = automaticItems[i].attachedProducts.length;
        productToAdd = _.extend({}, automaticItems[i]);
        productQuantity = productToAdd.quantity;
        //delete productToAdd.quantity;

        productToAdd.zone = -101;//0;
        productToAdd.aux = "";

        for (l = 0; l < productQuantity; l++) {
          productToAdd.newProgNumber = k;
          plainProducts.push(_.extend({}, productToAdd));
          k++;
        }
      }

      //Adding autocalculated items with validities
      for (i = 0; i < plainProducts.length; i++) {
        if (plainProducts[i].attachedProducts) {
          plainProducts[i].slot = [];
          for (j = 0; j < plainProducts[i].attachedProducts.length; j++) {
            plainProducts[i].slot.push({
              idLink: plainProducts[i].attachedProducts[j].progNumber
            });
          }
        }
      }

      var findMainCentralUnitSlotContact = function(packageClassIdToFind){
        for (x = 0; x < plainProducts.length; x++) {
          if (plainProducts[x].packageClassId == packageClassIdToFind) {
            return plainProducts[x].slot[0];
          }
        }
      };

      var findMainCentralUnitAttachedContact = function(packageClassIdToFind){
        for (x = 0; x < plainProducts.length; x++) {
          if (plainProducts[x].packageClassId == packageClassIdToFind) {
            return plainProducts[x].attachedProducts[0];
          }
        }
      };

      /* Assigning slot value to main control unit (copying from first and second contact) */
      for (i = 0; i < plainProducts.length; i++) {
        if (plainProducts[i].attachedProducts && plainProducts[i].attachedProducts.length>0 && plainProducts[i].type == "mainControlUnit") {

          for (j = 0; j < plainProducts[i].attachedProducts.length; j++) {
            var packageClassIdToFind = plainProducts[i].attachedProducts[j].packageClassId;
            var currentSlot = plainProducts[i].slot[j];

            if (!currentSlot.idLink) {
              plainProducts[i].slot[j]             = _.extend( {}, findMainCentralUnitSlotContact(packageClassIdToFind) );
              plainProducts[i].attachedProducts[j] = _.extend( {}, findMainCentralUnitAttachedContact(packageClassIdToFind) );
            }
          }

          //console.log(plainProducts[i]);
        }
      }


      /*Assigning values for N on plainProducts*/
      var zoneIds = _.uniq(_.map(plainProducts, function(el) {
        return el.zone;
      }));
      var productClassIds = _.uniq(_.map(plainProducts, function(el) {
        return el.packageClassId;
      }));
      var zoneIdsLength = zoneIds.length;
      var productClassIdsLength = productClassIds.length;
      var plainProductsLength = plainProducts.length;

      var getnumberOfInserters = function(plainProducts) {
        var counter = 0;
        for (i = 0; i < plainProducts.length; i++) {
          if (plainProducts[i].isInserter) {
            counter++;
          }
        }
        return counter;
      };

      for (var x = 0; x < zoneIdsLength; x++) {
        for (i = 0; i < productClassIdsLength; i++) {
          var nCounter = 1;
          var nCounterSirensExt = 1;
          var nCounterSirensInt = 1;
          var nCounterInserter = 1;
          var nCountersRadioInterface = getnumberOfInserters(plainProducts) + 1;
          for (j = 0; j < plainProductsLength; j++) {
            if (
              (plainProducts[j].zone === zoneIds[x]) /*&& (plainProducts[j].packageClassId === productClassIds[i])*/ && (
                (!plainProducts[j].validFor) || ((plainProducts[j].validFor) && (plainProducts[j].validFor.length === 0)))) {
              //plainProducts[j].N = nCounter;
              if (!plainProducts[j].packageClassId) {
                plainProducts[j].N = nCounter - 1;
              } else if (plainProducts[j].isArticleSystem) {
                plainProducts[j].N = 0;
                plainProducts[j].zone = -104;
                nCounter = 1;
              } else if (plainProducts[j].isExternalSiren) {
                plainProducts[j].N = nCounterSirensExt;
                plainProducts[j].zone = -103;
                nCounterSirensExt++;
                nCounter = nCounterSirensExt;
              } else if (plainProducts[j].isInternalSiren) {
                plainProducts[j].N = nCounterSirensInt;
                plainProducts[j].zone = -102;
                nCounterSirensInt++;
                nCounter = nCounterSirensInt;
              } else if (plainProducts[j].isInserter) {
                plainProducts[j].N = nCounterInserter;
                plainProducts[j].zone = 0;//-1;
                nCounterInserter++;
                nCounter = nCounterInserter;
              } else if (plainProducts[j].isRadioInterface || plainProducts[j].isRemoteControl) {
                plainProducts[j].N = nCountersRadioInterface;
                plainProducts[j].zone = 0;//-1;
                nCountersRadioInterface++;
                nCounter = nCountersRadioInterface;
              } else {
                plainProducts[j].N = nCounter;
                if (!plainProducts[j].isAllarmType) {
                  nCounter++;
                }
              }

            }
          }
        }
      }

      /*Assigning values for N on attached products*/
      for (i = 0; i < plainProductsLength; i++) {
        if ((plainProducts[i].attachedProducts) && (plainProducts[i].attachedProducts.length > 0)) {
          for (j = 0; j < plainProducts[i].attachedProducts.length; j++) {
            for (l = 0; l < plainProductsLength; l++) {
              if (plainProducts[l].progNumber === plainProducts[i].attachedProducts[j].idLink) {
                plainProducts[i].attachedProducts[j].N = plainProducts[l].N;
                plainProducts[i].attachedProducts[j].idLink = plainProducts[l].newProgNumber;
                break;
              }
            }
          }
        }
      }
      // console.log(plainProducts);
      // var arrayZone=[];
      // function compare(a,b) {
      //   if (a["N"] < b["N"])
      //      return -1;
      //   if (a["N"] > b["N"])
      //     return 1;
      //   return 0;
      // }
      // var zone=0;
      // for (i = 0; i < plainProducts.length; i++) {
      //   zone=plainProducts[i].zone;
      //   arrayZone.push(zone);
      // }
      
      // var uniqueZone = [];
      // $.each(arrayZone, function(i, el){
      //     if($.inArray(el, uniqueZone) === -1) uniqueZone.push(el);
      // });
      // uniqueZone.sort();
      // var tempArray=[],
      //     orderPlainProducts2=[];
      // for (var w = 0; w < uniqueZone.length; w++) {
      //   tempArray=[];
      //   for (var y = 0; y < plainProducts.length; y++) {
      //     if(plainProducts[y].zone==uniqueZone[w])
      //       tempArray.push(plainProducts[y]);
      //   }
      //   tempArray.sort(compare);
      //   for (k = 0; k < tempArray.length; k++) {
      //     orderPlainProducts2.push(tempArray[k]);
      //   }
        
      // }
      // console.log("dopo");
      // console.log(orderPlainProducts2);




      //var plainProducts2 = plainProducts.sort(function(a, b) {
      //    return a["zone"] - b["zone"];
      //    });
      // // plainProducts=orderPlainProducts2;
      // plainProducts=[];
      // for (i = 0; i < orderPlainProducts2.length; i++) {
      //   plainProducts.push(orderPlainProducts2[i]);
      // }

        var objectToAdd;
        for (i = 0; i < plainProductsLength; i++) {

          objectToAdd = {
            progNumber: plainProducts[i].newProgNumber,
            packageClassId: plainProducts[i].packageClassId,
            packageClassLabel: plainProducts[i].packageClassLabel,
            itemcode: plainProducts[i].productCode,
            slot: []
          };

          if (plainProducts[i].zone !== undefined) objectToAdd.Z = plainProducts[i].zone;

          if (plainProducts[i].N !== undefined) objectToAdd.N = plainProducts[i].N;

          if (plainProducts[i].attachedProducts) {
            for (j = 0; j < plainProducts[i].attachedProducts.length; j++) {
              for (l = 0; l < plainProducts[i].attachedProducts[j].Slots; l++) {
                var finalProductToAdd = _.extend({}, plainProducts[i].attachedProducts[j]);

                finalProductToAdd.Z = finalProductToAdd.Zone ? finalProductToAdd.Zone : 0;
                finalProductToAdd.N = finalProductToAdd.N ? finalProductToAdd.N : 0;

                delete finalProductToAdd.ProgressiveNumber;
                delete finalProductToAdd.Slots;
                delete finalProductToAdd.Zone;

                objectToAdd.slot.push(_.extend({}, finalProductToAdd));
              }
            }
          }

          modelToSend.push(objectToAdd);
        }

        var configuration;
        var getAddedProductDetails = function(packageDetails) {
          configuration.itemsConfiguratorAdded[i] = _.extend(configuration.itemsConfiguratorAdded[i], packageDetails);
          BticinoS4B.Instances.Models.ApplicationModel.getProducts(configuration.itemsConfiguratorAdded[i].packageClassId, function(productDetails) {
            productDetails.products = BticinoS4B.Instances.Models.ApplicationModel.filterProductsByCatalogAndWizardChoices(productDetails.products);

            configuration.itemsConfiguratorAdded[i] = _.extend(configuration.itemsConfiguratorAdded[i], productDetails.products[0]);

            if (configuration.itemsConfiguratorAdded[i].Qta) {
              configuration.itemsConfiguratorAdded[i].quantity = Number(configuration.itemsConfiguratorAdded[i].Qta);
              delete configuration.itemsConfiguratorAdded[i].Qta;
            }

            if ((configuration.itemsConfiguratorAdded[i].wizardChoices) && (configuration.itemsConfiguratorAdded[i].wizardChoices.length > 0)) {
              _.extend(configuration.itemsConfiguratorAdded[i], configuration.itemsConfiguratorAdded[i].wizardChoices[0]);
              delete configuration.itemsConfiguratorAdded[i].wizardChoices;
            }
          });
        };
        var getPackageDetails = function(data) {
          configuration = data.d;
          var itemsLength = data.d.items.length;

          for (i = 0; i < itemsLength; i++) {
            configuration.items[i].progNumber = Number(configuration.items[i].progNumber);
          }
          configuration.items = _.sortBy(configuration.items, function(element) {
            return element.progNumber;
          });

          for (i = 0; i < itemsLength; i++) {
            _.extend(modelToSend[i], configuration.items[i]);
          }
          configuration.items = modelToSend;

          var retrievePackageClass = function(counter) {
            BticinoS4B.Instances.Models.ApplicationModel.getPackageByIdPackageClass(configuration.items[counter].packageClassId, function(result) {
              configuration.items[counter] = _.extend(configuration.items[counter], result);
            });
          };

          for (i = 0; i < itemsLength; i++)
            retrievePackageClass(i);

          if (configuration.itemsConfiguratorAdded)
            for (i = 0; i < configuration.itemsConfiguratorAdded.length; i++)
              BticinoS4B.Instances.Models.ApplicationModel.getPackageByIdPackageClass(configuration.itemsConfiguratorAdded[i].packageClassId, getAddedProductDetails);

          /*Removing object from kit*/
          var retrieveFinalQuantity = function(item) {
            var configurationProductsFromKit = BticinoS4B.Instances.Models.ApplicationModel.get("configurationProductsFromKit"),
              productsFromKit = _.filter(configurationProductsFromKit, function(iterableItemFromKit) {
                return iterableItemFromKit.packageClassId === item.packageClassId;
              });

            if (productsFromKit.length > 0)
              item.quantity = item.quantity - productsFromKit[0].quantity;

            return item;
          };

          if (configuration.itemsConfiguratorAdded)
            for (i = configuration.itemsConfiguratorAdded.length - 1; i >= 0; i--) {
              configuration.itemsConfiguratorAdded[i] = retrieveFinalQuantity(configuration.itemsConfiguratorAdded[i]);
            }

          BticinoS4B.Instances.Models.ApplicationModel.set("configurationModel", configuration);
          var configurationModel = BticinoS4B.Instances.Models.ApplicationModel.get("configurationModel").items;
          var configurationModelLength = configurationModel.length;
          var completeConfigurationModel = new Backbone.Model();
          var z, n;

          for (i = 0; i < configurationModelLength; i++) {
            if (configurationModel[i].slot) {
              if (configurationModel[i].slot.length > 0) {
                for (j = 0; j < configurationModel[i].slot.length; j++) {
                  for (l = 0; l < configurationModel.length; l++) {
                    if (configurationModel[l].progNumber === configurationModel[i].slot[j].idLink) {
                      //tmp
                      z = configurationModel[i].slot[j].Z;
                      n = configurationModel[i].slot[j].N;
                      configurationModel[i].slot[j] = _.extend(configurationModel[i].slot[j], configurationModel[l]);
                      configurationModel[i].slot[j].Z = z;
                      configurationModel[i].slot[j].N = n;
                      break;
                    }
                  }
                }
              }
            }
          }
          var outOfZoneArticles = _.filter(configurationModel, function(element) {
            return (element.Z == -101);
          });
          var zones = _.difference(configurationModel, outOfZoneArticles);
          var zoneNumbers = _.sortBy(_.uniq(_.map(zones, function(element) {
            return element.Z;
          })), function(element) {
            return element;
          });

          var iterator = function(element) {
            return (element.Z === zoneNumbers[i]);
          };

          for (i = 0; i < zoneNumbers.length; i++) {
            zoneNumbers[i] = {
              number: zoneNumbers[i],
              items: _.filter(zones, iterator)
            };
          }
          completeConfigurationModel.set("outOfZoneArticles", outOfZoneArticles);
          completeConfigurationModel.set("zoneArticles", zoneNumbers);

          BticinoS4B.Instances.Models.ApplicationModel.set("getZoneName", function(zoneNumber) {
            var name;
            switch (zoneNumber) {
              case -104:
                name = "Articoli di sistema";
                break;
              case -103:
                name = "Sirene esterne";
                break;
              case -102:
                name = "Sirene interne";
                break;
              case -101:
                name = "Articoli Fuori zona";
                break;
              case 0:
                name = $.i18n._("IDS_WAI1001_9006");
                break;
              case 9:
                name = $.i18n._("IDS_WAI1001_9007");
                break;
              default:
                name = $.i18n._("IDS_WTR1001_9001") + " " + zoneNumber;
            }

            return name;
          });
          BticinoS4B.Instances.Models.ApplicationModel.set("completeConfiguration", completeConfigurationModel);
        };

        var lastModelSent = BticinoS4B.Instances.Models.ApplicationModel.get("lastModelSentToConfigurationService");

        objectToSend = JSON.stringify({
          catalogueId: BticinoS4B.Instances.Models.ApplicationModel.get("catalogId"),
          token: window.BticinoS4B.token,
          items: modelToSend
        });

        if (lastModelSent !== objectToSend) {
          BticinoS4B.Instances.Models.ApplicationModel.set("lastModelSentToConfigurationService", objectToSend);
          $.ajax({
            type: "POST",
            datatype: "json",
            contentType: "application/json",
            async: false,
            url: "/btreport/JSonInterface.asmx/JSonMakeConfigurator",
            data: objectToSend,
            success: function(data) {
              BticinoS4B.Instances.Models.ApplicationModel.set("lastConfiguration", JSON.stringify(data));
              getPackageDetails(data);
            }
          });
        } else
          getPackageDetails(JSON.parse(BticinoS4B.Instances.Models.ApplicationModel.get("lastConfiguration")));

        dataProvider.addItems("configurationItems", BticinoS4B.Instances.Models.ApplicationModel.get("configurationModel").itemsConfiguratorAdded);
      };

      CalculationClass.retrieveModels = function() {
        var modelToSave = {};
        var remotes, products;
        var i = 0,
          j = 0;

        var retrieveMainControlUnit = function(mainControlUnit) {
          if (mainControlUnit && mainControlUnit.get) {
            var toReturn = {};
            toReturn.packageClassId = mainControlUnit.get("packageClassId");
            toReturn.partOfKit = mainControlUnit.get("partOfKit");
            toReturn.kitValue = mainControlUnit.get("kitValue");
            toReturn.contacts = [];

            if (mainControlUnit.get("specialVars") && mainControlUnit.get("specialVars").contacts)
              for (var i = 0; i < mainControlUnit.get("specialVars").contacts.length; i++)
                toReturn.contacts.push({
                  connectedTo: mainControlUnit.get("specialVars").contacts[i].connectedTo
                });

            return toReturn;
          }
        };

        var retrievePowerSupply = function(powerSupply) {
          if (powerSupply && powerSupply.get) {
            var toReturn = {};
            toReturn.packageClassId = powerSupply.get("packageClassId");
            toReturn.partOfKit = powerSupply.get("partOfKit");
            toReturn.kitValue = powerSupply.get("kitValue");

            return toReturn;
          }
        };

        //Resetting values
        CalculationClass.resetValues();

        //Requesting model delivery
        window.BticinoS4B.eventAggregator.trigger("modelDeliver:request", this);

        /* Setting systemId */
        modelToSave.systemId = '#4';
        modelToSave.inserted = BticinoS4B.solution.intrusionDetection.inserted;

        if (BticinoS4B.Instances.Models.ApplicationModel.get('kitCode')) {
          modelToSave.kitCode = BticinoS4B.Instances.Models.ApplicationModel.get('kitCode');
        }
        /*Preparing for saving*/
        modelToSave.accessoryLine = {};

        /*Retrieving accessory line datas*/
        if (BticinoS4B.Instances.Models.ApplicationModel.get("choosenLine")) modelToSave.accessoryLine.line = BticinoS4B.Instances.Models.ApplicationModel.get("choosenLine").id;
        if (BticinoS4B.Instances.Models.ApplicationModel.get("choosenColor")) modelToSave.accessoryLine.color = BticinoS4B.Instances.Models.ApplicationModel.get("choosenColor").id;

        /*Retrieving power supply datas*/
        if (BticinoS4B.solution.intrusionDetection.powerSupply && BticinoS4B.solution.intrusionDetection.powerSupply.get && BticinoS4B.solution.intrusionDetection.powerSupply.get("packageClassId"))
          modelToSave.powerSupply = retrievePowerSupply(BticinoS4B.solution.intrusionDetection.powerSupply);

        /*Retrieving sirens datas*/
        if (BticinoS4B.solution.intrusionDetection.sirens && BticinoS4B.solution.intrusionDetection.sirens.get) {
          var externalSirens = BticinoS4B.solution.intrusionDetection.sirens.get("externalSirens"),
            externalSirensLength = externalSirens.length;

          modelToSave.sirens = {};
          modelToSave.sirens.externalSirens = [];
          modelToSave.sirens.internalSirens = {};

          for (i = 0; i < externalSirensLength; i++)
            modelToSave.sirens.externalSirens.push({
              packageClassId: BticinoS4B.solution.intrusionDetection.sirens.get("externalSirens")[i].packageClassId,
              value: BticinoS4B.solution.intrusionDetection.sirens.get("externalSirens")[i].value,
              partOfKit: BticinoS4B.solution.intrusionDetection.sirens.get("externalSirens")[i].partOfKit,
              kitValue: BticinoS4B.solution.intrusionDetection.sirens.get("externalSirens")[i].kitValue,
              enabled: BticinoS4B.solution.intrusionDetection.sirens.get("externalSirens")[i].enabled
            });

          modelToSave.sirens.internalSirens = {
            packageClassId: BticinoS4B.solution.intrusionDetection.sirens.get("internalSirens").packageClassId,
            enabled: BticinoS4B.solution.intrusionDetection.sirens.get("internalSirens").enable,
            value: BticinoS4B.solution.intrusionDetection.sirens.get("internalSirens").value
          };

        }

        /*Retrieving main control unit datas*/
        if (BticinoS4B.solution.intrusionDetection.kits && BticinoS4B.solution.intrusionDetection.kits.get) {
          modelToSave.kitsModel = {
            collection: []
          };
          currentModel = BticinoS4B.solution.intrusionDetection.kits.get("fetchedKits") ? BticinoS4B.solution.intrusionDetection.kits.get("fetchedKits") : [];
          for (i = 0; i < currentModel.length; i++) {
            if (currentModel[i].get("added")) {
              modelToSave.kitsModel.collection.push({
                packageClassId: currentModel[i].get("packageClassId")
              });
            }
          }
        }

        if (BticinoS4B.solution.intrusionDetection.mainControlUnit /*.get("packageClassId")*/ )
          modelToSave.mainControlUnit = retrieveMainControlUnit(BticinoS4B.solution.intrusionDetection.mainControlUnit);

        /*Retrieving remote controls*/
        if (BticinoS4B.solution.intrusionDetection.remoteControls && BticinoS4B.solution.intrusionDetection.remoteControls.get) {
          modelToSave.remoteControls = {};
          modelToSave.remoteControls.type = BticinoS4B.solution.intrusionDetection.remoteControls.get("type");
          modelToSave.remoteControls.remotes = [];
          remotes = BticinoS4B.solution.intrusionDetection.remoteControls.get("remotes");

          if (remotes) {
            for (i = 0; i < remotes.length; i++) {
              if (remotes[i].get("products")) {
                products = remotes[i].get("products");
                for (j = 0; j < products.length; j++) {
                  modelToSave.remoteControls.remotes.push({
                    packageClassId: products[j].get("packageClassId"),
                    value: products[j].get("value"),
                    type: products[j].get("type")
                  });
                }
              }
            }
          }
        }

        /*Retrieving radio system*/
        if (BticinoS4B.solution.intrusionDetection.radioSystems && BticinoS4B.solution.intrusionDetection.radioSystems.get) {
          modelToSave.radioSystems = {};

          //Retrieving interfaces
          if ((BticinoS4B.solution.intrusionDetection.radioSystems.get("interfaces")) && (BticinoS4B.solution.intrusionDetection.radioSystems.get("interfaces").length > 0)) {
            modelToSave.radioSystems.interfaces = [];

            for (i = 0; i < BticinoS4B.solution.intrusionDetection.radioSystems.get("interfaces").length; i++) {
              modelToSave.radioSystems.interfaces.push({
                enabled: BticinoS4B.solution.intrusionDetection.radioSystems.get("interfaces")[i].get("enabled"),
                packageClassId: BticinoS4B.solution.intrusionDetection.radioSystems.get("interfaces")[i].get("packageClassId"),
                value: BticinoS4B.solution.intrusionDetection.radioSystems.get("interfaces")[i].get("value")
              });
            }
          }

          //Retrieving remotes
          if ((BticinoS4B.solution.intrusionDetection.radioSystems.get("remotes")) && (BticinoS4B.solution.intrusionDetection.radioSystems.get("remotes").length > 0)) {
            modelToSave.radioSystems.remotes = [];

            for (i = 0; i < BticinoS4B.solution.intrusionDetection.radioSystems.get("remotes").length; i++) {
              modelToSave.radioSystems.remotes.push({
                enabled: BticinoS4B.solution.intrusionDetection.radioSystems.get("remotes")[i].get("enabled"),
                packageClassId: BticinoS4B.solution.intrusionDetection.radioSystems.get("remotes")[i].get("packageClassId"),
                value: BticinoS4B.solution.intrusionDetection.radioSystems.get("remotes")[i].get("value")
              });
            }
          }
        }

        //Inserters zone

        var insertersZone = [];
        var technicalBusAlarmZone = [];
        var technicalRadioAlarmZone = [];
        var inserters = (BticinoS4B.solution.intrusionDetection.inserters && BticinoS4B.solution.intrusionDetection.inserters.get) ? BticinoS4B.solution.intrusionDetection.inserters.get("collection").models : [];
        var technicalBusAlarm = (BticinoS4B.solution.intrusionDetection.technicalBusAlarm && BticinoS4B.solution.intrusionDetection.technicalBusAlarm.get) ? BticinoS4B.solution.intrusionDetection.technicalBusAlarm.get("collection").models : [];
        var technicalRadioAlarm = (BticinoS4B.solution.intrusionDetection.technicalRadioAlarm && BticinoS4B.solution.intrusionDetection.technicalRadioAlarm.get) ? BticinoS4B.solution.intrusionDetection.technicalRadioAlarm.get("collection").models : [];

        //Inserters section
        if (inserters)
          for (i = 0; i < inserters.length; i++) {
            insertersZone.push({
              number: inserters[i].get("number"),
              type: inserters[i].get("packageClassId"),
              description: inserters[i].get("description")
            });
          }

        //Inserters zone
        modelToSave.inserters = {
          insertersModel: {
            collection: insertersZone
          }
        };

        //Technical bus alarm section
        if (technicalBusAlarm)
          for (i = 0; i < technicalBusAlarm.length; i++) {
            technicalBusAlarmZone.push({
              number: technicalBusAlarm[i].get("number"),
              type: technicalBusAlarm[i].get("type"),
              _interface: technicalBusAlarm[i].get("_interface"),
              description: technicalBusAlarm[i].get("description")
            });
          }

        //Technical radio alarm section
        if (technicalRadioAlarm)
          for (i = 0; i < technicalRadioAlarm.length; i++) {
            technicalRadioAlarmZone.push({
              number: technicalRadioAlarm[i].get("number"),
              type: technicalRadioAlarm[i].get("packageClassId"),
              description: technicalRadioAlarm[i].get("description")
            });
          }

        //Auxiliaries zone
        modelToSave.auxiliaries = {
          technicalBusAlarmModel: {
            collection: technicalBusAlarmZone
          },
          technicalRadioAlarmModel: {
            collection: technicalRadioAlarmZone
          }
        };

        /*Retrieving zones*/
        modelToSave.zones = [];
        var zoneToAdd = {};
        var zonesCollection = [];
        if (BticinoS4B.solution.intrusionDetection.zones) {
          zonesCollection = BticinoS4B.solution.intrusionDetection.zones.collection;
        }

        var volumetricProtections, volumetricProtectionsLength,
          perimetralProtections, perimetralProtectionsLength, perimetralProtectionToAdd,
          radioSensors, radioSensorsLength;

        if (zonesCollection) {
          _.each(zonesCollection.models, function(zone) {
            zoneToAdd = {};
            volumetricProtectionModel = zone.get("volumetricProtectionModel");
            volumetricProtectionsLength = volumetricProtectionModel.models ? volumetricProtectionModel.models.length : 0;
            perimetralProtectionModel = zone.get("perimetralProtectionModel");
            perimetralProtectionsLength = perimetralProtectionModel.models ? perimetralProtectionModel.models.length : 0;
            radioSensorsModel = zone.get("radioSensorsModel");
            radioSensorssLength = radioSensorsModel.models ? radioSensorsModel.models.length : 0;
            zoneToAdd.number = zone.get("number");
            zoneToAdd.name = zone.get("name");
            zoneToAdd.description = zone.get("description");
            zoneToAdd.volumetricProtectionModel = {
              collection: []
            };
            zoneToAdd.perimetralProtectionModel = {
              collection: []
            };
            zoneToAdd.radioSensorsModel = {
              collection: []
            };

            //Retrieving volumetric protections
            if (volumetricProtectionModel) {
              volumetricProtectionModel = volumetricProtectionModel.get("collection");
              volumetricProtectionModel.collection = [];
              volumetricProtectionModelLength = volumetricProtectionModel.length;
              for (i = 0; i < volumetricProtectionModelLength; i++)
                zoneToAdd.volumetricProtectionModel.collection.push({
                  number: volumetricProtectionModel.models[i].get("number"),
                  type: volumetricProtectionModel.models[i].get("packageClassId"),
                  description: volumetricProtectionModel.models[i].get("description"),
                  partOfKit: volumetricProtectionModel.models[i].get("partOfKit"),
                  kitValue: volumetricProtectionModel.models[i].get("kitValue")
                });
            }

            //Retrieving perimetral protections
            if (perimetralProtectionModel) {
              perimetralProtectionModel = perimetralProtectionModel.get("collection");
              perimetralProtectionModel.collection = [];
              perimetralProtectionModelLength = perimetralProtectionModel.length;

              for (i = 0; i < perimetralProtectionModelLength; i++) {
                perimetralProtectionToAdd = {
                  _interface: {
                    packageClassId: perimetralProtectionModel.models[i].get("_interface").packageClassId,
                    isMCUContact: perimetralProtectionModel.models[i].get("_interface").specialVars.mainControlUnitContact ? perimetralProtectionModel.models[i].get("_interface").specialVars.mainControlUnitContact : undefined
                  },
                  protections: []
                };

                //Adding protections
                for (j = 0; j < perimetralProtectionModel.models[i].get("protections").length; j++) {
                  perimetralProtectionToAdd.protections.push({
                    number: perimetralProtectionModel.models[i].get("protections")[j].get("number"),
                    type: perimetralProtectionModel.models[i].get("protections")[j].get("packageClassId"), //get("type").packageClassId,
                    value: perimetralProtectionModel.models[i].get("protections")[j].get("value"),
                    state: perimetralProtectionModel.models[i].get("protections")[j].get("state")
                  });
                }

                zoneToAdd.perimetralProtectionModel.collection.push(perimetralProtectionToAdd);
              }
            }

            //Retrieving volumetric protections
            if (radioSensorsModel) {
              radioSensorsModel = radioSensorsModel.get("collection");

              if (radioSensorsModel) {
                radioSensorsModel.collection = [];
                radioSensorsModelLength = radioSensorsModel.length;

                for (i = 0; i < radioSensorsModelLength; i++)
                  zoneToAdd.radioSensorsModel.collection.push({
                    number: radioSensorsModel.models[i].get("number"),
                    type: radioSensorsModel.models[i].get("packageClassId"),
                    description: radioSensorsModel.models[i].get("description")
                  });
              } else
                radioSensorsModel = {
                  collection: []
                };
            }

            modelToSave.zones.push(zoneToAdd);

          });
        }

        modelToSave.optionals = [];
        if (BticinoS4B.solution.intrusionDetection.optionalPackages) {
          _.each(BticinoS4B.solution.intrusionDetection.optionalPackages, function(optionalPackage) {
            _.each(optionalPackage.get("products").packagesByOptionalPackageId, function(optionalProduct) {
              if (optionalProduct.get && optionalProduct.get("value") && (optionalProduct.get("value") > 0)) {
                var optionalToAdd = {};
                optionalToAdd.productCode = optionalProduct.get("productCode");
                optionalToAdd.value = optionalProduct.get("value");
                modelToSave.optionals.push(optionalToAdd);
              }
            });
          });
        }
        return modelToSave;
      };

      // Required, return the module for AMD compliance
      return CalculationClass;

    });